module.exports = __webpack_public_path__ + "img/online-img@x2.fdff3b9.png";